<template>
 <div>
	<el-dialog :visible.sync="visible"
		:title="$t('slb.text.deleteCert')"
		:close-on-click-modal="false"
		:before-close="handleClose" 
        size="tiny"
        class="del-root">
		<div class="tip-earlyWarning" style="margin-bottom:10px">
			<i class="jc-icon-warning cff96"></i>
			{{$t('slb.sentence.deleteWarning')}}								
		</div>
        <p>{{ $t('slb.sentence.sureDeleteCert', [rowInfo.name]) }}</p>
		<div slot="footer">
			<el-button @click="cancelBind">
				{{ $t('privateNetInstance.cancel') }}
			</el-button>
			<el-button @click="sureBind"
				type="primary">
				{{ $t('privateNetInstance.bindSure') }}
			</el-button>
		</div>
	</el-dialog>
	<jcb-opt-protect 
		:visible.sync="operationProtectVisible" 
		:action-type="OperationConstant.DELETE_CERT"
		@success="onSuccess" @error="onError">
	</jcb-opt-protect>
 </div>
</template>

<script>
import operationProtect from '@/mixins/operationProject';
import { OperationConstant } from '@/common/Constants';
export default {
	name: 'deleteCert',
	mixins: [operationProtect],
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		
		rowInfo: {
			type: Object,
			default: () => {}
		},
        
		pageSource: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			// 操作保护弹框是否显示
			operationProtectVisible: false,	
		};
	},
	computed: {
		OperationConstant: () => OperationConstant
	},
	methods: {
		handleClose() {
			this.$emit('update:visible', false);
		},
		/**
		 * 取消删除操作
		 */
		cancelBind() {
			this.handleClose();
		},
		/**
		 * 确定删除打开操作保护
		 */
		sureBind() {
			this.openOperationProtect(OperationConstant.DELETE_CERT, this.rowInfo, this.pageSource);
			this.handleClose();
		},
		/**
		 * 删除负载均衡证书
		 * @param headers
		 */
		deleteCert(headers) {
				const params = {
				certId: this.rowInfo.certId,
				region: this.rowInfo.region,
			};
			Ajax.del('/api/cps/deleteCertificate', params, { headers }).then(() => {
				this.$emit('refresh');
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch(ex) {
					console.log(ex);
				}
			})
			.finally(() => {
				this.handleClose();
			});
			
		},
		
	},
};
</script>

<style scoped lang="scss">
    .del-root {
        p {
            text-align: left;
            margin: 12px;
            line-height: 1.5;
            color: #212121;
            word-break: break-all;
            font-size: 14px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/slb/deleteCert.vue